import { Council, Document } from 'types';

export const getCouncilAnnouncementDocumentId = (
  announcementDocument:
    | Council['announcementDocument']
    | { _id?: string }
    | null
): string | undefined => {
  if (!announcementDocument) return undefined;
  if (typeof announcementDocument === 'string') return announcementDocument;
  if (
    typeof announcementDocument === 'object' &&
    '_id' in announcementDocument
  ) {
    return (announcementDocument as { _id: string })._id;
  }
  return undefined;
};

/** The /download endpoint only applies to documents with URL in bucket
 * (e.g. uploaded PDF). The TEMPLATES only have editorModel. */
export const councilAnnouncementHasStoredFile = (
  announcementDocument: Council['announcementDocument'],
  documents: Document[] | undefined
): boolean => {
  const id = getCouncilAnnouncementDocumentId(announcementDocument);
  if (!id || !documents?.length) return false;

  const doc = documents.find((d) => String(d._id) === String(id));
  return Boolean(doc?.url);
};

/** HTML for the PDF: template linked to the council (`announcementTemplateDoc`)
 * or the announcement document in Redux (same template via `announcementDocument`). */
export const getCouncilAnnouncementEditorHtml = (
  announcementTemplateDoc: Document | undefined,
  currentCouncil: Council,
  documents: Document[] | undefined
): string | undefined => {
  if (announcementTemplateDoc?.editorModel) {
    return announcementTemplateDoc.editorModel;
  }
  const id = getCouncilAnnouncementDocumentId(
    currentCouncil?.announcementDocument
  );
  if (!id || !documents?.length) return undefined;
  const doc = documents.find((d) => String(d._id) === String(id));
  return doc?.editorModel;
};
